import type { ErrorStrategy } from '../types';
import { t } from 'i18next';

// currently we just have to handle a "minItems" of 1,
// if we need to show different messages based on the limit, we could access params.limit
export const minItemsStrategy: ErrorStrategy = ({ instancePath }) => {
  return {
    path: instancePath,
    message: t('Validation.PropertyRequired'),
  };
};
